<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>    
    <a class="navbar-brand" routerLink="home">Legal Ad Review</a>
    <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <ul class="navbar-nav">
            <li class="nav-item" *ngIf="authenticated">
                <a class="nav-link" routerLinkActive="active-link" routerLink="home">Dashboard</a>
            </li>
            <li class="nav-item" *ngIf="authenticated && !existingForm && !approver">
                <a class="nav-link" routerLinkActive="active-link" routerLink="form">New Legal Ad Form</a>
            </li>
            <li class="nav-item" *ngIf="authenticated && existingForm && !approver">
                <a class="nav-link" routerLink="form">New Legal Ad Form</a>
            </li>
            <li class="nav-item" *ngIf="authenticated && existingForm">
                <a class="nav-link active-form" routerLinkActive="active-link" routerLink="form">Legal Ad Form {{formId}}</a>
            </li>
        </ul>
    </div>
    <div *ngIf="authenticated" class="nav navbar-right hidden-xs hidden-sm text-blue">
      {{ authService.getName() }}
    </div>
    &nbsp;&nbsp;
    <form class="navbar-form navbar-right">
      <input *ngIf="!authenticated" (click)="login()" type="button" class="btn btn-outline-info btn-rounded my-4 z-depth-0" value="Login">
      <input *ngIf="authenticated" (click)="logout()" type="button" class="btn btn-outline-info btn-rounded my-4 z-depth-0" value="Logout"> 
    </form>
</nav>